import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { SubscriptorFormRouters, SUBSCRIPTOR_ADD_PATH } from './subscriptor';
import { UserRouters } from './user';
import { maintainerFormRouters, otherRouters } from './maintainer';
import Login from '../pages/login';
import { isLogged } from '../services/authorization-service';
import User from '../services/user-service';

const modularizedRoutes = [
  ...SubscriptorFormRouters,
  ...UserRouters,
  ...maintainerFormRouters,
  ...otherRouters
];

const goToLogin = () => {
  return window.location.assign('/login');
};
const ProtectedRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => (isLogged() ? <Component {...props} /> : goToLogin() ? '' : '')}
  />
);

const routes = modularizedRoutes.map((elem, index) => (
  <ProtectedRoute key={index.toString()} {...elem} />
));
routes.push(<Route exact path="/" render={() => <Redirect to={SUBSCRIPTOR_ADD_PATH} />} />);

routes.push(
  <Route
    exact
    path="/login"
    render={props => {
      if (isLogged()) {
        User.logout();
        window.location.reload(true);
        return;
      }
      return <Login {...props} />;
    }}
  />
);

export default () => routes;
